import React, {ReactEventHandler, useEffect, useRef, useState} from 'react';
import {DefaultTheme, useTheme} from 'styled-components';
import {useFetchSVG} from './helpers/useFetchSVG';

// NOTE: this can be removed later when and if we can make webpack
// respect tsconfig.json as DefaultTheme is already defined and used
// through tsconfig.json
interface MyTheme extends DefaultTheme {
    colors: {
        primary: {
            main: string;
        };
        secondary: {
            main: string;
        };
    };
}

type IconType = {
    iconName: string;
    disabled?: boolean;
    onClick?: ReactEventHandler;
    width?: string;
    style?: React.CSSProperties;
    color?: 'primary' | 'secondary' | string;
    'data-cy'?: string;
    showAltText?: boolean;
    className?: string;
};

const Icon = ({
    iconName,
    width,
    color,
    disabled = false,
    onClick,
    style,
    'data-cy': dataCy,
    showAltText = true,
    className,
}: IconType) => {
    const theme = useTheme() as MyTheme;
    const [icon, setIcon] = useState<React.ReactElement>(null);
    const {imageData, fetchIcon, imageFetched} = useFetchSVG(
        theme.colors.primary.main,
        theme.colors.secondary.main,
        color
    );

    useEffect(() => {
        if (imageData) {
            setIcon(
                <img
                    className={className}
                    src={`${imageData}`}
                    style={disabled ? {...style, opacity: 0} : style}
                    onClick={!disabled && onClick ? onClick : undefined}
                    width={width}
                    data-cy={dataCy}
                />
            );
        }
    }, [imageData, onClick]);

    const iconNameRef = useRef(iconName);
    useEffect(() => {
        if (!imageFetched || iconName != iconNameRef.current) {
            iconNameRef.current = iconName;
            if (showAltText) {
                setIcon(<div>Fetching Icon</div>);
            }
            void fetchIcon(iconName, 'MODULE');
        }
    }, [theme, iconName, imageFetched]);

    if (typeof iconName !== 'undefined' && iconName !== '') {
        return icon;
    }
};

export default Icon;
